import { ADICIONAR_PASSAGEIRO, ADICIONAR_PASSAGEIROS, ALTERAR_PASSAGEIRO } from '../../actions/types';

const initialState = undefined

export default function reducerAdicionarPassageiro (state = [], action = initialState) {
  switch (action.type) {
    case ADICIONAR_PASSAGEIROS: {
      return action.payload
    }
    case ADICIONAR_PASSAGEIRO: {
      const passageiro = action.payload
      const passageiros = Object.assign([], state.passageiros)
      passageiros.push(passageiro)
      return passageiros
    }
    case ALTERAR_PASSAGEIRO: {
      const passageiro = action.payload
      const indice = state.itens.indexOf(passageiro)
      const novaPassageiro = Object.assign({}, passageiro)
      const passageiros = Object.assign([], state.passageiros)
      passageiros[indice] = novaPassageiro

      return passageiros
    }
    default:
      return state
  }
}
